import * as React from 'react';
import { isFunction } from '@resi-media/resi-ui';
import { useParams } from 'react-router';
import useSWR from 'swr';
import type { SWRResponse } from 'swr';
import { CONTINUE_WATCHING } from '@sites/constants/generic';
import { useFeed } from '@sites/contexts/feedContext';
import type CustomError from '@sites/helpers/customError';
import type { Playlists } from '@sites/types';

type _Props = {
  children: React.ReactNode | ((values: SWRResponse<Playlists.Get.Playlist, CustomError>) => React.ReactNode);
  tokenData?: { jwt: string };
  url?: string;
};

const PlaylistFetch = ({ children, tokenData: tokenDataProp, url: urlProp }: _Props) => {
  const { playlistId } = useParams<'customerSite' | 'playlistId' | 'videoId'>();
  const { getPlaylist, setVideos, tokenData: tokenDataCtx } = useFeed();

  const url = urlProp ?? getPlaylist(playlistId)?.url;
  const tokenData = tokenDataProp ?? tokenDataCtx;
  const isContinueWatching = playlistId === CONTINUE_WATCHING;

  const { data, error, ...rest } = useSWR<Playlists.Get.Playlist>(
    tokenData?.jwt && !isContinueWatching ? [url, tokenData.jwt] : null
  );

  React.useEffect(() => {
    if (data?.videos.length) {
      setVideos(
        data.videos.map((v) => ({
          ...v,
          playlistId: data.id,
          playlistName: data.name,
        }))
      );
    }
  }, [data, setVideos]);

  return <React.Fragment>{isFunction(children) ? children({ data, error, ...rest }) : children}</React.Fragment>;
};

PlaylistFetch.displayName = 'PlaylistFetch';

export { PlaylistFetch };
